import AuthModel from "./AuthModel";
import qs from 'qs';
import configVM from "../ViewModel/ConfigVM";

class LoginModel extends AuthModel {

    async loginByUsername(
        username: string,
        password: string
    ): Promise<any> {

        var body = {
            username: username,
            password: password
        };

        var res = await this.post('/login', qs.stringify(body), {}, this.headers);
        return res.data;
    }

    async loginByPhoneNumber(
        mobile_number: string,
        password: string
    ): Promise<any> {

        var body = {
            mobile_number: mobile_number,
            password: password,
            country_code: configVM.countryCode
        };

        var res = await this.post('/login', qs.stringify(body), {}, this.headers);
        return res.data;
    }
}

const loginModel = new LoginModel();
export default loginModel;